import { render, staticRenderFns } from "./VModalRemarksImport.vue?vue&type=template&id=27d999a9&"
import script from "./VModalRemarksImport.vue?vue&type=script&lang=ts&"
export * from "./VModalRemarksImport.vue?vue&type=script&lang=ts&"
import style0 from "./VModalRemarksImport.vue?vue&type=style&index=0&id=27d999a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports